// Generat automat din README.md
import React from 'react';
import { CreditCard, Clock, CheckCircle, AlertCircle } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import { mockData, getStatusColor } from '../../utils/mockData';

const UrmarirelPlati = () => {
  const paymentData = [
    { id: 'PAY-001', invoice: 'INV-001', client: 'Compania ABC SRL', amount: '2,450.00 RON', dueDate: '2024-03-20', status: 'Plătită' },
    { id: 'PAY-002', invoice: 'INV-002', client: 'Firma XYZ SA', amount: '1,750.00 RON', dueDate: '2024-03-25', status: 'În așteptare' },
    { id: 'PAY-003', invoice: 'INV-003', client: 'Business 123 SRL', amount: '3,200.00 RON', dueDate: '2024-03-18', status: 'Expirată' }
  ];

  const columns = [
    { header: 'ID Plată', key: 'id' },
    { header: 'Factură', key: 'invoice' },
    { header: 'Client', key: 'client' },
    { header: 'Sumă', key: 'amount' },
    { header: 'Scadență', key: 'dueDate' },
    { 
      header: 'Status', 
      key: 'status',
      render: (value) => <Badge variant={getStatusColor(value)}>{value}</Badge>
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Urmărire Plăți</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Monitorizare automată a plăților și notificări pentru facturi restante
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Plăți Asteptate" icon={Clock}>
          <div className="text-2xl font-bold text-yellow-600">12</div>
          <div className="text-sm text-gray-600">5,450 RON total</div>
        </Card>
        <Card title="Plăți Primite" icon={CheckCircle}>
          <div className="text-2xl font-bold text-green-600">89</div>
          <div className="text-sm text-gray-600">89,250 RON total</div>
        </Card>
        <Card title="Plăți Restante" icon={AlertCircle}>
          <div className="text-2xl font-bold text-red-600">7</div>
          <div className="text-sm text-gray-600">8,900 RON total</div>
        </Card>
        <Card title="Rata de Colectare" icon={CreditCard}>
          <div className="text-2xl font-bold text-primary-600">92%</div>
          <div className="text-sm text-green-600">+3% această lună</div>
        </Card>
      </div>

      <Card title="Status Plăți" subtitle="Toate plățile din sistem">
        <Table columns={columns} data={paymentData} />
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Plăți pe Următoarele 30 de Zile">
          <div className="space-y-3">
            <div className="flex justify-between items-center p-3 bg-gray-50 dark:bg-gray-700 rounded">
              <span className="text-sm font-medium">15 Martie - 21 Martie</span>
              <span className="text-sm font-bold">12,450 RON</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-gray-50 dark:bg-gray-700 rounded">
              <span className="text-sm font-medium">22 Martie - 28 Martie</span>
              <span className="text-sm font-bold">8,750 RON</span>
            </div>
            <div className="flex justify-between items-center p-3 bg-gray-50 dark:bg-gray-700 rounded">
              <span className="text-sm font-medium">29 Martie - 4 Aprilie</span>
              <span className="text-sm font-bold">6,200 RON</span>
            </div>
          </div>
        </Card>

        <Card title="Notificări Automatizate">
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span className="text-sm">Email înainte cu 7 zile de scadență</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span className="text-sm">SMS în ziua scadenței</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-green-500" />
              <span className="text-sm">Apel automat după 3 zile de întârziere</span>
            </div>
            <div className="flex items-center space-x-3">
              <Clock className="w-5 h-5 text-yellow-500" />
              <span className="text-sm">Raport săptămânal către management</span>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default UrmarirelPlati;